/* eslint-disable react-hooks/rules-of-hooks */
// src/hooks/Tax/useTaxTypeList.ts
import { useCallback, useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '@store/hooks';
import { getTaxManegerByTaxTypeList } from '@store/Finance/TaxManagers/TaxManagerSlice'; // عدّل المسار حسب مشروعك

const EMPTY_TAX_LIST: any[] = [];

export const useTaxTypeList = (taxType: string) => {
  const dispatch = useAppDispatch();

  const taxList = useAppSelector(state => state.TaxManager?.taxTypeList ?? EMPTY_TAX_LIST);
  const loading = useAppSelector(state => state.TaxManager?.loading);
  const error = useAppSelector(state => state.TaxManager?.error);

  const reload = useCallback(() => {
    dispatch(getTaxManegerByTaxTypeList(taxType));
  }, [dispatch, taxType]);

  useEffect(() => {
     
    dispatch(getTaxManegerByTaxTypeList(taxType));
  }, [dispatch, taxType]);

  return { taxList, loading, error, reload };
};
